export default __webpack_public_path__ + "static/media/2.a1f38181.jpg";